import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Control, SegmentedControls, Title, Subtitle } from './styles';
import { GRID_UNIT } from '../../utilities/grid';
export var SegmentedControl = function (_a) {
  var _b = _a.tabs,
    tabs = _b === void 0 ? [] : _b,
    onClick = _a.onClick,
    _c = _a.selected,
    selected = _c === void 0 ? 0 : _c,
    _d = _a.variant,
    variant = _d === void 0 ? 'primary' : _d;
  var controlsRef = useRef(null);
  var selectedRef = useRef(selected);
  var calcHighlight = function () {
    if (controlsRef === null || controlsRef === void 0 ? void 0 : controlsRef.current) {
      var _a = controlsRef.current,
        style = _a.style,
        offsetWidth = _a.offsetWidth;
      var controlWidth = variant === 'secondary' ? offsetWidth / tabs.length - 2 : (offsetWidth - GRID_UNIT) / tabs.length;
      var tabOffset = controlWidth * selected;
      var lastTabSelected = selected === tabs.length - 1;
      var highlightWidth = variant === 'secondary' ? controlWidth : controlWidth - GRID_UNIT;
      var highlightXPos = variant === 'secondary' ? tabOffset + selected + 1 : tabOffset + GRID_UNIT;
      var highlightLastTabPos = variant === 'secondary' ? offsetWidth - highlightWidth - 3 : tabOffset + GRID_UNIT;
      style.setProperty('--highlight-width', "".concat(highlightWidth, "px"));
      style.setProperty('--highlight-x-pos', "".concat(lastTabSelected ? highlightLastTabPos : highlightXPos, "px"));
      // add the transition only after the first selected elem has changed
      if (selectedRef.current !== selected) {
        style.setProperty('--transition', 'transform 0.3s ease-in-out, width 0.3s ease-in-out');
      }
    }
  };
  useEffect(function () {
    calcHighlight();
    window.addEventListener('resize', calcHighlight);
    return function () {
      window.removeEventListener('resize', calcHighlight);
    };
  }, [selected, tabs]);
  return tabs.length ? _jsx(SegmentedControls, {
    ref: controlsRef,
    "data-cy-label": "segmented-tab-controls",
    variant: variant,
    children: tabs.map(function (_a, i) {
      var title = _a.title,
        subtitle = _a.subtitle;
      var titleStyleName = variant === 'secondary' ? 'bodySmall' : 'label';
      var activeTitleStyleName = variant === 'secondary' ? 'labelSmall' : 'label';
      return _jsx(Control, {
        onClick: function () {
          return onClick(i);
        },
        active: selected === i,
        variant: variant,
        children: _jsxs(_Fragment, {
          children: [_jsx(Title, {
            el: "div",
            styleName: selected === i ? activeTitleStyleName : titleStyleName,
            active: selected === i,
            segmentedControlVariant: variant,
            children: title
          }), variant === 'primary' && subtitle && _jsx(Subtitle, {
            el: "div",
            styleName: "labelSmall",
            active: selected === i,
            segmentedControlVariant: variant,
            children: subtitle
          })]
        })
      }, i);
    })
  }) : null;
};